import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO, sortToDTO } from './api/mapper'
import { GET_AB_TESTS_FOR_TABLE } from './api/query'
import { AbTestsForTableDTO, Data, Variables } from './api/types'
import { AbTestsForTable, UseGetAbTests, UseGetAbTestsProps } from './types'

export const useGetAbTests = ({
  filters,
  first,
  last,
  sort,
}: UseGetAbTestsProps): UseGetAbTests => {
  const [abTests, setAbTests] = useState<AbTestsForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const {
        abTests: { nodes: abTests, totalCount: count },
      } = data

      if (abTests) {
        setAbTests(abTests.map((abTest: AbTestsForTableDTO): AbTestsForTable => fromDTO(abTest)))
        setCount(count)
      }
    },
    query: GET_AB_TESTS_FOR_TABLE,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
    },
  })

  return { abTests, count, loading }
}
